export function ClockIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M10,18.22A8.22,8.22,0,1,1,18.22,10,8.23,8.23,0,0,1,10,18.22ZM10,3.43A6.57,6.57,0,1,0,16.57,10,6.58,6.58,0,0,0,10,3.43Zm2.46,9.86a.82.82,0,0,1-.58-.24L9.42,10.58A.83.83,0,0,1,9.18,10V6.71a.82.82,0,0,1,1.64,0v3l2.23,2.22a.83.83,0,0,1,0,1.17A.82.82,0,0,1,12.46,13.29Z" />
    </svg>
  )
}
